// extracted by mini-css-extract-plugin
export var orderDetails = "_ka-2";
export var orderImage = "_ka-1";
export var orderMeta = "_ka-3";
export var orderSummary = "_ka-0";
export var rightArrow = "_ka-4";